export default __webpack_public_path__ + "static/media/eye-blue.7c04fd89.svg";